export const COOKIES_NAME_CONFIG = {
  ACCESS_TOKEN: "sme_access_token",
  REFRESH_TOKEN: "sme_refresh_token",
  USER_DATA: "sme_user_data",
  TENANT_CONTEXT: "sme_tenant_context",
  SESSION_ID: "sme_session_id",
  XSRF_TOKEN: "sme_xsrf_token",
};
